import angular from 'angular';

import { AddSiteToGroupController } from './site-group-add-site.controller';
import { SiteGroupEditionController } from './site-group-edition.controller';



angular
  .module('site-groups', [])
  .controller('AddSiteToGroupController', AddSiteToGroupController)
  .controller('SiteGroupEditionController', SiteGroupEditionController);

  
